import React from "react";
import TextField from "@material-ui/core/TextField";
import { Button } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

function FilterBox() {
  return (
    <div
      className="filter-box-container"
      style={{
        position: "fixed",
        top:100
      }}
    >
      {["Price", "Collection", "Artist"].map((filter) => (
        <div className="filter">
          <div
            style={{
              width: "200px",
              marginLeft: "30px",
              marginTop: "20px",
              backgroundColor: "#0E0E0E",
              borderRadius: "10px 0px 0px 10px",
              height: "40px",
              marginBottom: "30px",
            }}
          >
            <p
              style={{
                color: "#CDCDCD",
                letterSpacing: "1px",
                paddingLeft: "10px",
              }}
            >
              {filter}
            </p>
          </div>
          <div>
            <Button
              variant="contained"
              style={{
                color: "#CDCDCD",
                backgroundColor: "#0E0E0E",
                marginTop: "20px",
                height: "40px",
                width: "10px",
                borderRadius: "0px 10px 10px 0px",
                boxShadow: "none",
              }}
            >
              <ArrowDropDownIcon />
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default FilterBox;
